// export const updateSEO = (seoData) => {
//   const { title, description, keywords } = seoData;

//   // Update Title
//   if (title) {
//     document.title = title;
//   }

//   // Update Description
//   const metaDescription = document.querySelector('meta[name="description"]');
//   if (metaDescription) {
//     metaDescription.setAttribute('content', description || "");
//   }

//   // Update Keywords
//   const metaKeywords = document.querySelector('meta[name="keywords"]');
//   if (metaKeywords) {
//     metaKeywords.setAttribute('content', keywords || "");
//   }
 
//   // Update Open Graph tags
//   const ogTitle = document.querySelector('meta[property="og:title"]');
//   if (ogTitle) ogTitle.setAttribute('content', title || "");

//   const ogDescription = document.querySelector('meta[property="og:description"]');
//   if (ogDescription) ogDescription.setAttribute('content', description || "");

//   // Update Twitter tags
//   const twitterTitle = document.querySelector('meta[name="twitter:title"]');
//   if (twitterTitle) twitterTitle.setAttribute('content', title || "");

//   const twitterDescription = document.querySelector('meta[name="twitter:description"]');
//   if (twitterDescription) twitterDescription.setAttribute('content', description || "");
// };

// export const defaultSEO = {
//   title: "Dev Rishi Hospital",
//   description: "Dev Rishi Hospital - Providing world-class healthcare services with compassion and expertise.",
//   keywords: "hospital, healthcare, doctors, Dev Rishi Hospital, medical services"
// };

// export const pageSEO = {
//   home: {
//     title: "Home | Dev Rishi Hospital",
//     description: "Welcome to Dev Rishi Hospital. We provide world-class healthcare services with compassion and advanced medical expertise.",
//     keywords: "Dev Rishi Hospital, home, healthcare, medical services, best hospital, multispecialty hospital"
//   },
//   about: {
//     title: "About Us | Dev Rishi Hospital",
//     description: "Learn more about Dev Rishi Hospital, our experienced team of doctors, history, mission, and dedication to patient care.",
//     keywords: "about Dev Rishi Hospital, hospital history, mission, patient care, experienced doctors"
//   },
//   visionMission: {
//     title: "Vision & Mission | Dev Rishi Hospital",
//     description: "Discover the Vision and Mission of Dev Rishi Hospital. We strive for excellence in healthcare and patient satisfaction.",
//     keywords: "vision and mission, hospital vision, healthcare excellence, patient satisfaction"
//   },
//   services: {
//     title: "Our Services | Dev Rishi Hospital",
//     description: "Explore the wide range of medical services and specialties provided by Dev Rishi Hospital.",
//     keywords: "medical services, hospital specialties, ICU, OPD, emergency, healthcare services"
//   },
//   doctors: {
//     title: "Our Doctors | Dev Rishi Hospital",
//     description: "Meet the expert and dedicated team of doctors at Dev Rishi Hospital, specialized in various medical fields.",
//     keywords: "Dev Rishi Hospital doctors, medical experts, specialists, healthcare professionals"
//   },
//   appointment: {
//     title: "Book an Appointment | Dev Rishi Hospital",
//     description: "Book an appointment online with our expert doctors at Dev Rishi Hospital for a consultation.",
//     keywords: "book appointment, doctor consultation, online appointment hospital"
//   },
//   contact: {
//     title: "Contact Us | Dev Rishi Hospital",
//     description: "Get in touch with Dev Rishi Hospital. Find our location, contact number, and other essential details for emergency and queries.",
//     keywords: "contact Dev Rishi Hospital, hospital location, emergency phone number, hospital contact"
//   },
//   career: {
//     title: "Careers | Dev Rishi Hospital",
//     description: "Join the Dev Rishi Hospital team. Explore our current openings and build a rewarding career in healthcare.",
//     keywords: "hospital jobs, healthcare careers, Dev Rishi Hospital vacancy, medical jobs"
//   },
//   ayushman: {
//     title: "Ayushman Bharat | Dev Rishi Hospital",
//     description: "Dev Rishi Hospital is empanelled under Ayushman Bharat. Avail cashless treatment and quality healthcare.",
//     keywords: "Ayushman Bharat, cashless treatment, PMJAY, Ayushman hospital"
//   },
//   blogs: {
//     title: "Health Blogs | Dev Rishi Hospital",
//     description: "Read the latest health tips, medical updates, and informative articles written by experts at Dev Rishi Hospital.",
//     keywords: "health blogs, medical articles, health tips, wellness"
//   },
//   news: {
//     title: "News & Events | Dev Rishi Hospital",
//     description: "Stay updated with the latest news, announcements, and events at Dev Rishi Hospital.",
//     keywords: "hospital news, medical events, Dev Rishi Hospital updates"
//   },
//   notFound: {
//     title: "Page Not Found | Dev Rishi Hospital",
//     description: "The page you are looking for does not exist.",
//     keywords: "404, page not found, Dev Rishi Hospital"
//   }
// };




// Ab DOM-manipulation wala updateSEO() function nahi chahiye (SSR-incompatible hai).
// Sirf data source ki tarah use hoga — SEOHead component isi se values leta hai.

export const defaultSEO = {
  title: "Dev Rishi Hospital",
  description: "Dev Rishi Hospital - Providing world-class healthcare services with compassion and expertise.",
  keywords: "hospital, healthcare, doctors, Dev Rishi Hospital, medical services"
};

export const pageSEO = {
  home: {
    title: "Home | Dev Rishi Hospital",
    description: "Welcome to Dev Rishi Hospital. We provide world-class healthcare services with compassion and advanced medical expertise.",
    keywords: "Dev Rishi Hospital, home, healthcare, medical services, best hospital, multispecialty hospital"
  },
  about: {
    title: "About Us | Dev Rishi Hospital",
    description: "Learn more about Dev Rishi Hospital, our experienced team of doctors, history, mission, and dedication to patient care.",
    keywords: "about Dev Rishi Hospital, hospital history, mission, patient care, experienced doctors"
  },
  visionMission: {
    title: "Vision & Mission | Dev Rishi Hospital",
    description: "Discover the Vision and Mission of Dev Rishi Hospital. We strive for excellence in healthcare and patient satisfaction.",
    keywords: "vision and mission, hospital vision, healthcare excellence, patient satisfaction"
  },
  services: {
    title: "Our Services | Dev Rishi Hospital",
    description: "Explore the wide range of medical services and specialties provided by Dev Rishi Hospital.",
    keywords: "medical services, hospital specialties, ICU, OPD, emergency, healthcare services"
  },
  doctors: {
    title: "Our Doctors | Dev Rishi Hospital",
    description: "Meet the expert and dedicated team of doctors at Dev Rishi Hospital, specialized in various medical fields.",
    keywords: "Dev Rishi Hospital doctors, medical experts, specialists, healthcare professionals"
  },
  appointment: {
    title: "Book an Appointment | Dev Rishi Hospital",
    description: "Book an appointment online with our expert doctors at Dev Rishi Hospital for a consultation.",
    keywords: "book appointment, doctor consultation, online appointment hospital"
  },
  contact: {
    title: "Contact Us | Dev Rishi Hospital",
    description: "Get in touch with Dev Rishi Hospital. Find our location, contact number, and other essential details for emergency and queries.",
    keywords: "contact Dev Rishi Hospital, hospital location, emergency phone number, hospital contact"
  },
  career: {
    title: "Careers | Dev Rishi Hospital",
    description: "Join the Dev Rishi Hospital team. Explore our current openings and build a rewarding career in healthcare.",
    keywords: "hospital jobs, healthcare careers, Dev Rishi Hospital vacancy, medical jobs"
  },
  ayushman: {
    title: "Ayushman Bharat | Dev Rishi Hospital",
    description: "Dev Rishi Hospital is empanelled under Ayushman Bharat. Avail cashless treatment and quality healthcare.",
    keywords: "Ayushman Bharat, cashless treatment, PMJAY, Ayushman hospital"
  },
  blogs: {
    title: "Health Blogs | Dev Rishi Hospital",
    description: "Read the latest health tips, medical updates, and informative articles written by experts at Dev Rishi Hospital.",
    keywords: "health blogs, medical articles, health tips, wellness"
  },
  news: {
    title: "News & Events | Dev Rishi Hospital",
    description: "Stay updated with the latest news, announcements, and events at Dev Rishi Hospital.",
    keywords: "hospital news, medical events, Dev Rishi Hospital updates"
  },
  notFound: {
    title: "Page Not Found | Dev Rishi Hospital",
    description: "The page you are looking for does not exist.",
    keywords: "404, page not found, Dev Rishi Hospital"
  }
};
